module.exports = __webpack_public_path__ + "static/media/bus1.4100f004.jpg";